import { render, staticRenderFns } from "./wkHonorModalForm.vue?vue&type=template&id=234229c8&scoped=true"
import script from "./wkHonorModalForm.vue?vue&type=script&lang=js"
export * from "./wkHonorModalForm.vue?vue&type=script&lang=js"
import style0 from "./wkHonorModalForm.vue?vue&type=style&index=0&id=234229c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234229c8",
  null
  
)

export default component.exports